import { FieldViewModel, IDataLayer, IDataLayerType, ILayerViewModel, IOmniaShell } from "../../omnia"
import { PopupArgs } from "./types"

export function showPopup(sourceLayer: IDataLayer, field: FieldViewModel, dynamicScale: boolean, targetType: IDataLayerType, shell: IOmniaShell) {

    const args: PopupArgs = {
        sourceLayer,
        field,
        dynamicScale,
        targetType
    }

    return shell.showComponentAsDialog("omnia-maplayer-simplify-popup", args, { size: "full-screen" })

}

export function showTestPopup(sourceLayer: ILayerViewModel, targetType: IDataLayerType, shell: IOmniaShell) {

    return sourceLayer.setVisible(true).then(() => showPopup(sourceLayer.datalayer, sourceLayer.field, false, targetType, shell))

}
